export default __webpack_public_path__ + "static/media/hht2_ep7_speaking_04.da7305a5.png";